import React, { useEffect, useState } from "react";

import "./HomePageSec1.scss";
import "../../../Assets/style/_grid.scss";
import TextUnderline from "../../../Component/TextUnderline/TextUnderline";
import useWindowSize from "../../../Utils/useWindowSize/useWindowSize";

import ImgAbout from "../../../Assets/images/HomePage/main-01@2x.png";
import { useTranslation } from "react-i18next";
import HeadMore from "../../HeadMore/HeadMore";
function HomePageSec1(props: any) {
  const { width, height } = useWindowSize();
  const { t } = useTranslation();
  const [styleInfoDecs, setStyleInfoDecs] = useState<any>({
    fontSize: `calc( 24px - 10%)`,
    fontFamily: "$montserrat",
    lineHeight: "0.8",
    color: "#111111",
    fontWeight: "400",
    marginRight: "5px",
  });
  const [borderHeightInfoDecs, setBorderHeightDecs] = useState<number>(1);




  const decs = (
    <p>
      {t('artistDescription')}
    </p>
  );
  const decs2 = (
    <p>
      {t('artistIntroduce')}
    </p>
  );

  const [styleInfoTitle1, setStyleInfoTitle1] = useState<any>({
    fontSize: `calc( 24px - 10%)`,
    fontFamily: "$montserrat",
    lineHeight: "0.8",
    color: "#111111",
    fontWeight: "600",
    marginRight: "5px",
  });
  const [borderHeightInfoTitle1, setBorderHeightTitle1] = useState<number>(3);
  const inforTitle1 = t('aboutTitle');
  const inforTitle2 = t('introduceTitle');

  useEffect(() => {
    if (width > 1024) {
      setStyleInfoDecs({
        fontSize: `calc( 24px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "400",
        marginRight: "5px",
      });
      setBorderHeightDecs(1);
      setStyleInfoTitle1({
        fontSize: `calc( 24px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "600",
        marginRight: "5px",
      });
      setBorderHeightTitle1(3);
    }
    if (width <= 1024 && width > 900) {
      setStyleInfoDecs({
        fontSize: `calc( 22px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "400",
        marginRight: "5px",
      });
      setBorderHeightDecs(1);
      setStyleInfoTitle1({
        fontSize: `calc( 22px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "600",
        marginRight: "5px",
      });
      setBorderHeightTitle1(3);
    } else if (width <= 900 && width > 768) {
      setStyleInfoDecs({
        fontSize: `calc( 20px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "400",
        marginRight: "5px",
      });
      setBorderHeightDecs(1);
      setStyleInfoTitle1({
        fontSize: `calc( 20px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "600",
        marginRight: "5px",
      });
      setBorderHeightTitle1(2);
    } else if (width <= 768 && width > 480) {
      setStyleInfoDecs({
        fontSize: `calc( 16px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "400",
        marginRight: "5px",
      });
      setStyleInfoTitle1({
        fontSize: `calc( 16px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "600",
        marginRight: "5px",
      });
      setBorderHeightTitle1(1);
    } else if (width <= 480 && width > 320) {
      setStyleInfoDecs({
        fontSize: `calc( 16px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "400",
        marginRight: "5px",
      });
      setStyleInfoTitle1({
        fontSize: `calc( 16px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "600",
        marginRight: "5px",
      });
      setBorderHeightTitle1(1);
    } else if (width <= 320) {
      setStyleInfoDecs({
        fontSize: `calc( 16px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "400",
        marginRight: "5px",
      });
      setStyleInfoTitle1({
        fontSize: `calc( 16px - 10%)`,
        fontFamily: "$montserrat",
        lineHeight: "0.8",
        color: "#111111",
        fontWeight: "600",
        marginRight: "5px",
      });
    }
  }, [width]);

  return (
    <div className="home-section_1">
      <div className="home-section_1-wrapper">
        <HeadMore Decs={decs} />
        <div className="title-head">
          <div className="title-head_left w-7">
            <h3>Artist</h3>
            {width <= 768 ? (
              <h3 className="mr-left">XUXU</h3>
            ) : (
              <h3 className="mr-left">XU</h3>
            )}
          </div>
          <div className="title-head_right w-3">
            <h3 className="mr-left">XU</h3>
          </div>
        </div>
        <div className="home-1-about">
          <div className="w-7 home-1-about_left ">
            <div className="image">
              <div className="image-wrapper">
                <img src={ImgAbout} alt="" />
              </div>
            </div>
          </div>
          <div className="w-3 home-1-about_right">
            <div className="home-1-about_right-decs">
              {inforTitle1.split(" ").map((item: any, index: any) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfoTitle1}
                  borderheight={borderHeightInfoTitle1}
                >
                  {item}
                </TextUnderline>
              ))}
              <p>{t('artistLocation')}</p>
            </div>
            <div className="home-1-about_right-link">
              <a href="">View About</a>
            </div>
          </div>
        </div>
        <div className="home-1-intro">
          <div className="w-7 home-1-intro_left ">
            <div className="home-1-intro_left-decs">
              {inforTitle2.split(" ").map((item: any, index: any) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfoTitle1}
                  borderheight={borderHeightInfoTitle1}
                >
                  {item}
                </TextUnderline>
              ))}
              {decs2}
            </div>
          </div>
          <div className="w-3 home-1-intro_right">
            <div className="home-1-intro_right-inside">
              <h3>XUXU</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePageSec1;
